export default {
  palette: {
    primary: {
      light: '#5776FF',
      main: '#022CE6',
      dark: '#3f51b5',
      contrastText: '#fff',
      orange: '#F78F1E',
      white: '#FFFFFF',
    },
    secondary: {
      light: '#F7F7F7',
      semiLight: '#E5E5E5',
      main: '#8A8A8A',
      dark: '#FFA500',
      contrastText: '#FFA500',
      chip: '#E0E0E0',
    },
    status: {
      success: '#42BD5D',
      error: '#EC544A',
    },
    green: {
      bg: 'rgba(66, 189, 93, 0.1)',
      color: '#42BD5D',
      hoverColor: 'rgba(66, 189, 93, 0.8)',
    },
    red: {
      bg: 'rgba(236, 84, 74, 0.1)',
      color: '#EC544A',
      dark: '#A83A31',
      hoverColor: 'rgba(236, 84, 74, 0.8)',
    },
    grey: {
      bg: 'rgba(167, 167, 167, 0.1)',
      color: '#BBBBBB',
      hoverColor: 'rgba(167, 167, 167, 0.8)',
    },
    darkGrey: {
      bg: '#F2F2F2',
      color: '#5B5B5B',
    },
    blue: {
      bg: 'rgba(0, 128, 255, 0.05)',
      color: '#0080FF',
      hoverColor: 'rgba(0, 128, 255, 0.8)',
    },
    alarm: {
      bg: 'rgba(236, 84, 74, 0.1)',
      color: '#FF4C4C',
      hoverColor: 'rgba(236, 84, 74, 0.8)',
    },
    darkBlue: {
      bg: 'rgba(0, 0, 255, 0.05)',
      color: '#0000FF',
      hoverColor: 'rgba(0, 0, 255, 0.8)',
    },
    violet: {
      bg: 'rgba(117, 74, 236, 0.05)',
      color: '#754AEC',
      hoverColor: 'rgba(117, 74, 236, 0.8)',
    },
    aquamarine: {
      bg: 'rgba(30, 0, 255, 0.05)',
      color: '#1ECCB7',
      hoverColor: 'rgba(30, 0, 255, 0.8)',
    },
    lightCyan: {
      bg: 'rgba(20, 237, 251, 0.05)',
      color: '#14EDFB',
      hoverColor: 'rgba(20, 237, 251, 0.8)',
    },
    pink: {
      bg: 'rgba(245, 69, 164, 0.05)',
      color: '#F545A4',
      hoverColor: 'rgba(245, 69, 164, 0.8)',
    },
    orange: {
      bg: 'rgba(247, 143, 30, 0.05)',
      color: '#F78F1E',
      hoverColor: 'rgba(247, 143, 30, 0.8)',
    },
    warmSand: {
      bg: 'rgba(220, 180, 153, 0.05)',
      color: '#DCB499',
      hoverColor: 'rgba(220, 180, 153, 0.8)',
    },
    darkPink: {
      bg: 'rgba(255, 50, 173, 0.05)',
      color: '#FF32AD',
      hoverColor: 'rgba(255, 50, 173, 0.8)',
    },
    deepBlue: {
      bg: 'rgba(2, 44, 230, 0.05)',
      color: '#022CE6',
      hoverColor: 'rgba(2, 44, 230, 0.8)',
    },
    cyan: {
      bg: 'rgba(21, 236, 250, 0.05)',
      color: '#15ECFA',
      hoverColor: 'rgba(21, 236, 250, 0.8)',
    },
    darkOrange: {
      bg: 'rgba(255, 153, 4, 0.05)',
      color: '#FF9304',
      hoverColor: 'rgba(255, 153, 4, 0.8)',
    },
    yellow: {
      bg: 'rgba(253, 224, 6, 0.05)',
      color: '#FDE006',
      hoverColor: 'rgba(253, 224, 6, 0.8)',
    },
    purple: {
      bg: 'rgba(125, 128, 255, 0.05)',
      color: '#7D80FF',
      hoverColor: 'rgba(125, 128, 255, 0.8)',
    },
    lightBlue: {
      bg: 'rgba(25, 155, 251, 0.05)',
      color: '#19B7FB',
      hoverColor: 'rgba(25, 155, 251, 0.8)',
    },
    yellowLight: {
      bg: 'rgba(255, 253, 29, 0.05)',
      color: '#FFFD1E',
      hoverColor: 'rgba(255, 253, 29, 0.8)',
    },
    darkRed: {
      bg: 'rgba(255, 0, 17, 0.05)',
      color: '#FF0011',
      hoverColor: 'rgba(255, 0, 17, 0.8)',
    },
    darkTeal: {
      bg: 'rgba(7, 136, 132, 0.05)',
      color: '#078884',
      hoverColor: 'rgba(7, 136, 132, 0.8)',
    },
    lightViolet: {
      bg: 'rgba(159, 56, 255, 0.05)',
      color: '#9F38FF',
      hoverColor: 'rgba(159, 56, 255, 0.8)',
    },
    lime: {
      bg: 'rgba(187, 255, 81, 0.05)',
      color: '#B1FF51',
      hoverColor: 'rgba(187, 255, 81, 0.8)',
    },
    pinkLight: {
      bg: 'rgba(255, 100, 214, 0.05)',
      color: '#FF64D6',
      hoverColor: 'rgba(255, 100, 214, 0.8)',
    },
    blueLight: {
      bg: 'rgba(89, 145, 213, 0.05)',
      color: '#5991D5',
      hoverColor: 'rgba(89, 145, 213, 0.8)',
    },
    pinkSoft: {
      bg: 'rgba(255, 177, 200, 0.05)',
      color: '#FFB1C8',
      hoverColor: 'rgba(255, 177, 200, 0.8)',
    },
    orangeBright: {
      bg: 'rgba(255, 204, 33, 0.05)',
      color: '#FFC021',
      hoverColor: 'rgba(255, 204, 33, 0.8)',
    },
    purpleSoft: {
      bg: 'rgba(221, 218, 255, 0.05)',
      color: '#DDA5FF',
      hoverColor: 'rgba(221, 218, 255, 0.8)',
    },
    orangeRed: {
      bg: 'rgba(255, 102, 0, 0.05)',
      color: '#FF6600',
      hoverColor: 'rgba(255, 102, 0, 0.8)',
    },

    header: 'white',
    alternateTextColor: 'red',
    text: {
      primary: '#222',
      secondary: '#BBBBBB',
    },
  },
  status: {
    danger: 'orange',
  },
  shape: {
    borderRadius: 8,
  },

  typography: {
    button: {
      fontWeight: 400,
      textTransform: 'capitalize',
    },
    fontFamily: ['Poppins', 'sans-serif'].join(','),
  },

  overrides: {
    MuiButtonBase: {
      root: {
        '& svg': {
          width: 24,
          height: 24,
          '@media (min-width: 1440px)': {
            width: 20,
            height: 20,
            minHeight: 20,
            minWidth: 20,
          },
        },
        '&.Mui-disabled': {
          background: 'rgba(0,0,0,0.05)',
        },
      },
    },
    MuiButton: {
      root: {
        fontSize: 16,
        lineHeight: '24px',
        borderRadius: 8,
        '&.default-submit-action': {
          minWidth: 150,
          height: 44,
        },
      },
      label: {
        fontWeight: 600,
      },
      outlined: {
        padding: '12px 15px',
      },
    },
    MuiIconButton: {
      root: {
        '&.Mui-disabled path': {
          // stroke: '#BBB',
        },
        '&.in-row': {
          marginLeft: 8,
          '&:first-child': {
            marginLeft: 0,
          },
        },
      },
    },
    IconButton: {
      outlined: {
        '& svg.stroke': {
          '& path': {
            stroke: '#8A8A8A !important',
          },
        },
        '& svg.fill': {
          '& path': {
            fill: '#8A8A8A !important',
          },
        },
        '&:hover': {
          '& svg.fill path': {
            fill: `#022CE6 !important`,
          },
          '& svg.stroke path': {
            stroke: `#022CE6 !important`,
          },
        },
      },
      contained: {
        '&.add-button': {
          width: 'auto',
        },
        '&:hover': {
          '& svg.fill path': {
            fill: `#022CE6 !important`,
          },
          '& svg.stroke path': {
            stroke: `#022CE6 !important`,
          },
        },
        '& svg.stroke': {
          '& path': {
            stroke: `#fff !important`,
          },
        },
        '& svg.fill': {
          '& path': {
            fill: `#fff !important`,
          },
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 8,
      },
    },
    MuiInputBase: {
      root: {
        fontSize: 16,
        lineHeight: '18px',
        '& input::placeholder': {
          fontSize: 16,
          lineHeight: '18px',
          '@media (max-width: 1440px)': {
            fontSize: 14,
            lineHeight: '16px',
          },
        },
        '@media (max-width: 1440px)': {
          fontSize: 14,
          lineHeight: '16px',
        },
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        fontSize: 16,
        lineHeight: '18px',
        '& input::placeholder': {
          fontSize: 16,
          lineHeight: '18px',
          '@media (max-width: 1440px)': {
            fontSize: 14,
            lineHeight: '16px',
          },
        },
        '@media (max-width: 1440px)': {
          fontSize: 14,
          lineHeight: '16px',
        },
      },
    },
    MuiTypography: {
      body1: {
        fontSize: 16,
      },
      root: {
        '&.weight': {
          '&-regular': {
            fontWeight: 400,
          },
          '&-medium': {
            fontWeight: 500,
          },
          '&-semibold': {
            fontWeight: 600,
          },
          '&-bold': {
            fontWeight: 700,
          },
        },
        '&.size': {
          '&-xs': {
            fontSize: 10,
            lineHeight: '15px',
          },
          '&-s': {
            fontSize: 12,
            lineHeight: '18px',
          },
          '&-m': {
            fontSize: 16,
            lineHeight: '24px',
          },
        },
      },
    },
  },
};
